import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { ColumnProgressBarConfig, TableColumnFormat } from '@blaze-shared/elements-domain';
import { AnyFormatValueOptions, FormatValuePipe } from '@blaze-shared/shared-feature';

import { ProgressBarSegmentPipe } from '../../elements/table/pipes/progress-bar-segment.pipe';

@Component({
  selector: 'blaze-inline-progress-bar',
  imports: [FormatValuePipe, ProgressBarSegmentPipe],
  templateUrl: './inline-progress-bar.component.html',
  styleUrl: './inline-progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClasses()',
  },
})
export class InlineProgressBarComponent {
  value = input.required<string>();
  isColumnPercent = input.required<boolean>();
  config = input.required<ColumnProgressBarConfig | undefined>();
  extremes = input.required<{ min: number; max: number }>();

  protected hostClasses = computed((): string => {
    const common = 'flex flex-col gap-4';
    if (this.config()?.align === 'right') {
      return `${common} items-end`;
    } else if (this.config()?.align === 'center') {
      return `${common} items-center`;
    }
    return `${common} items-start`;
  });

  protected valueFormat = computed((): TableColumnFormat => {
    const cfg = this.config();
    if (cfg?.extras === 'value') {
      return cfg.format ?? 'number';
    }
    return 'percentage';
  });

  protected valueFormatOptions = computed((): AnyFormatValueOptions => {
    const cfg = this.config();
    if (cfg?.extras !== 'value') {
      return {};
    }
    return { precision: cfg.precision, currency: cfg.currency };
  });
}
